module.exports = __webpack_public_path__ + "static/media/cancel-process.d534870b.svg";